export const pickerWinnersCriteria = {
  "LEGO-gdjkr": {
    validEntrys: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 50],
    validChallengeIds: ["lego-f1-july-test"],
  },
};
